const user = {
    state: {
        userInfo: undefined,
        token: '',
        userId: '',
        nickname: '',
        scanUIType: 1,
        qrErrorMsg: ''
    },
    mutations: {
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo;
            for (let i in userInfo) {
                state[i] = userInfo[i];
            }
        },
        SET_SCAN_UI_TYPE: (state, e) => {
            state.scanUIType = e;
        },
        SET_QR_ERROR_MSG: (state, e) => {
            state.qrErrorMsg = e;
        }
    },
    actions: {
        setUserInfo({
            commit
        }, arg) {
            commit('SET_USER_INFO', arg)
        },
        setScanUiType({
            commit
        }, arg) {
            commit('SET_SCAN_UI_TYPE', arg)
        },
        setQrErrorMsg({
            commit
        }, arg) {
            commit('SET_QR_ERROR_MSG', arg)
        }
    }
}

export default user